<div *ngIf="loggedIn">
    <ul>
        <li class="chain"><em></em></li>
        <li class="link" (click)="navigate('home')" [ngClass]="activeClass(['home'])" id="home">
            <p>HOME</p>
        </li>
        <li class="link" (click)="navigate('canvas')" [ngClass]="activeClass(['canvas'])" id="canvas">
            <p>CANVAS</p>
        </li>
        <li class="link" (click)="navigate('trl')" [ngClass]="activeClass(['trl'])" id="trl">
            <p>TRL</p>
        </li>
        <li class="link" (click)="navigate('brief')" [ngClass]="activeClass(['brief'])" id="brief">
            <p>MODEL</p>
        </li>
        <li class="link" [ngClass]="activeClass(['analysis', 'nodes', 'input'])" id="analysis" [matMenuTriggerFor]="sustainability">
            <p>SUSTAINABILITY</p>
        </li>
        <li class="link" (click)="navigate('insights')" [ngClass]="activeClass(['insights'])" id="insights">
            <p>INSIGHTS</p>
        </li>
        <li class="hamburger" id="menu" [matMenuTriggerFor]="menu">
            <p></p>
        </li>
    </ul>

    <mat-menu #sustainability="matMenu">
        <button mat-menu-item (click)="navigate('nodes')">
            <mat-icon class="drop-down-icon" class="drop-down-icon">share</mat-icon>
            <span class="dropdown-menu-item">NODE SELECTION</span>
        </button>
        <button mat-menu-item (click)="navigate('input')">
            <mat-icon class="drop-down-icon">create</mat-icon>
            <span class="dropdown-menu-item">INPUT</span>
        </button>
        <button mat-menu-item (click)="navigate('analysis')">
            <mat-icon class="drop-down-icon">insights</mat-icon>
            <span class="dropdown-menu-item">ANALYSIS</span>
        </button>
    </mat-menu>
    <mat-menu #menu="matMenu">
        <button mat-menu-item class="readonly">
            <mat-icon class="drop-down-icon">account_circle</mat-icon>
            <span class="dropdown-menu-item">{{authService.username()}}</span>
        </button>
        <button *ngIf="authService.hasRole('Admin')" mat-menu-item (click)="usermanagement()">
            <mat-icon class="drop-down-icon">account_circle</mat-icon>
            <span class="dropdown-menu-item">USER MANAGEMENT</span>
        </button>
        <button mat-menu-item (click)="chooseAssessment()">
            <mat-icon class="drop-down-icon">assignment</mat-icon>
            <span class="dropdown-menu-item">MANAGE ASSESSMENTS</span>
        </button>
        <button mat-menu-item (click)="export()">
            <mat-icon class="drop-down-icon">download</mat-icon>
            <span class="dropdown-menu-item">EXPORT</span>
        </button>
        <button mat-menu-item (click)="help()">
            <mat-icon class="drop-down-icon">help</mat-icon>
            <span class="dropdown-menu-item">MANUAL</span>
        </button>
        <button mat-menu-item (click)="about()">            
            <mat-icon class="drop-down-icon">info</mat-icon>
            <span class="dropdown-menu-item">ABOUT</span>
        </button>
        <button *ngIf="!config.anonymous" mat-menu-item (click)="logout()">
            <mat-icon class="drop-down-icon">login</mat-icon>
            <span class="dropdown-menu-item">LOGOUT</span>
        </button>
    </mat-menu>
</div>